import { useParams } from 'react-router-dom';
import { AttributeCode } from 'services/model/model.service';
import { BenchmarkingMarketplaceDrillDown } from 'pages/Benchmarking/drilldown/BenchmarkingMarketplaceDrillDown';
import { BenchmarkingCountryDrillDown } from 'pages/Benchmarking/drilldown/BenchmarkingCountryDrillDown';

export function BenchmarkingDrillDown() {
  const { attributeType, attributeValue } = useParams<{ attributeType: AttributeCode; attributeValue: string }>();

  return (
    <>
      {attributeValue && (
        <>
          {attributeType === 'chnMarketplace' && <BenchmarkingMarketplaceDrillDown marketplace={attributeValue} />}
          {attributeType === 'chnCountry' && <BenchmarkingCountryDrillDown country={attributeValue} />}
        </>
      )}
    </>
  );
}
